import styled from 'styled-components'

export const Wrapper = styled.div`
  background-color: ${props => props.theme.palette.general.light};
  display: flex;
  height: 100vh;
  align-items: center;
  justify-content: center;
  color: ${props => props.theme.palette.primary.alpha};
  font-weight: ${props => props.theme.font.default.bold};
  font-size: 18px;
`
